import { fitToSize, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
const defaultOptions = {
    sideCutRatio: 0.35,
    arcRadiusYRatio: 0.3,
    arcRadiusXRatio: 0.08
};
/**
 * A visual element that renders a display symbol with angled left side and curved right edge.
 * Extends Rectangle and provides functionality for creating display/output device shapes.
 */
export class Display extends Rectangle {
    /**
     * Creates a new Display instance.
     * @param options Configuration options for the display shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /** @hidden */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const arcRadiusY = height * this.options.arcRadiusYRatio;
        const arcRadiusX = width * this.options.arcRadiusXRatio;
        const arcStartX = width - arcRadiusX;
        const cut = width * this.options.sideCutRatio;
        drawingElement
            .moveTo([cut, 0])
            .lineTo([arcStartX, 0])
            .arcTo([arcStartX, height], arcRadiusX, arcRadiusY, false, true)
            .lineTo([arcStartX, height])
            .lineTo([cut, height])
            .lineTo([0, height / 2])
            .close();
        fitToSize(this.drawingElement, width, height, strokeWidth);
    }
}
